import type couriersEn from "./couriers.en";

const couriersAr: Record<keyof typeof couriersEn, string> = {
  "cour.title": "شركات الشحن",
  "cour.hint": "اربط حساباتك لدى شركات الشحن لشراء ملصقات الشحن من الطلبات وتتبّع الطرود وعرض أسعار الشحن المباشرة عند إتمام الطلب.",
  "cour.connected": "مرتبط",
  "cour.not_connected": "غير مرتبط",
  "cour.connect": "ربط",
  "cour.connect_title": "ربط {name}",
  "cour.labels": "الملصقات",
  "cour.tracking": "التتبّع",
  "cour.rates": "أسعار مباشرة",
  "cour.cod": "الدفع عند الاستلام",
  "cour.webhook_on": "تصل تحديثات التتبّع تلقائياً: تم تسجيل Webhook لدى شركة الشحن.",
  "cour.webhook_auto": "عند الحفظ نسجّل Webhook للتتبّع لدى شركة الشحن لتصلك تحديثات التوصيل تلقائياً.",
  "cour.test_mode_hint": "يستخدم نظام الاختبار لدى شركة الشحن وبيانات الاختبار: لا تُحجز طرود حقيقية.",
  "cour.enable": "استخدام {name} للملصقات والأسعار",
  "cour.enable_hint": "يستطيع الموظفون شراء ملصقات {name} من الطلبات، ويمكن لأسعار الشحن المباشرة استخدامه عند إتمام الطلب.",
  "cour.nbox.hint": "شركة لوجستيات قطرية بتقنيات حديثة: توصيل في نفس اليوم ودفع عند الاستلام وتتبّع مباشر.",
  "cour.nbox.steps": "أنشئ حساب بائع لدى NBOX (nbox.qa) وأعدّ متجرك في NBOX NOW.\nأدخل البريد الإلكتروني وكلمة المرور اللذين تسجّل بهما الدخول إلى NBOX NOW، ونطاق متجرك (معرّف المتجر لدى NBOX).\nاحفظ: نسجّل لك Webhook للتتبّع لدى NBOX لتصل تحديثات التوصيل تلقائياً.\nاختبر الاتصال. في وضع الاختبار تُحجز الملصقات على نظام الاختبار لدى NBOX.",
  "cour.aramex.hint": "شحن سريع داخل الخليج ودولياً: ملصقات وأسعار مباشرة وتتبّع ودفع عند الاستلام.",
  "cour.aramex.steps": "افتح حساب أعمال لدى أرامكس واطلب من مدير حسابك صلاحية الوصول إلى API (Shipping Services API).\nترسل أرامكس اسم مستخدم وكلمة مرور لـ API، إضافة إلى رقم الحساب والرمز السري والكيان (مثل DOH) ورمز الدولة (مثل QA).\nأدخلها أدناه. في وضع الاختبار استخدم حساب الاختبار الذي تمنحه أرامكس.\nاحفظ ثم اختبر الاتصال. يُحدَّث التتبّع كل ساعتين. لا تتيح أرامكس إلغاء شحنة محجوزة عبر API: تواصل معها عند الحاجة.",
  "cour.dhl_express.hint": "شحن دولي سريع مع DHL: ملصقات وأسعار مباشرة وتتبّع.",
  "cour.dhl_express.steps": "تحتاج إلى حساب DHL Express. سجّل في developer.dhl.com وأنشئ تطبيقاً مع MyDHL API واطلب من مسؤول حسابك في DHL Express اعتماده.\nتصدر DHL مفتاح API وكلمة سر (للاختبار أولاً). أدخلها مع رقم حسابك في DHL Express المكوّن من 9 أرقام.\nاحفظ ثم اختبر الاتصال. يُحدَّث التتبّع كل ساعتين.\nلا تحصّل DHL الدفع عند الاستلام. ولا تُحتسب بوليصة غير مستخدمة، لذا فإن إلغاء ملصق DHL هنا يبطله فقط.",
  "cour.field.email": "البريد الإلكتروني",
  "cour.field.password": "كلمة المرور",
  "cour.field.shop_domain": "نطاق المتجر",
  "cour.field.username": "اسم مستخدم API",
  "cour.field.account_number": "رقم الحساب",
  "cour.field.account_pin": "الرمز السري للحساب",
  "cour.field.account_entity": "كيان الحساب",
  "cour.field.account_country_code": "رمز دولة الحساب",
  "cour.field.api_key": "مفتاح API",
  "cour.field.api_secret": "كلمة سر API",
  "lbl.create": "إنشاء ملصق شحن",
  "lbl.title": "إنشاء ملصق شحن",
  "lbl.buy": "شراء الملصق",
  "lbl.bought": "تم إنشاء الملصق · {tracking}",
  "lbl.get_rates": "عرض الأسعار",
  "lbl.no_couriers": "اربط شركة شحن لشراء ملصقات الشحن.",
  "lbl.connect": "الانتقال إلى الشحن والتوصيل",
  "lbl.route": "من {from} إلى {to}",
  "lbl.courier": "شركة الشحن",
  "lbl.service": "الخدمة",
  "lbl.service_default": "اختيار شركة الشحن",
  "lbl.package": "الطرد",
  "lbl.package_none": "المقاس الافتراضي (20 × 15 × 10 سم)",
  "lbl.weight": "الوزن الإجمالي (كجم)",
  "lbl.weight_hint": "المنتجات مع التغليف.",
  "lbl.no_rates": "لم ترجع شركة الشحن سعراً لهذا الطرد.",
  "lbl.days": "{n, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يوماً} other {# يوم}}",
  "lbl.collect_cod": "تحصيل {amount} عند الاستلام",
  "lbl.collect_cod_hint": "تحصّل شركة الشحن المبلغ المستحق من العميل وتدفعه لك.",
  "lbl.no_cod": "لا تحصّل {name} الدفع عند الاستلام.",
  "lbl.notify": "إرسال تفاصيل التتبّع إلى العميل",
  "lbl.print": "طباعة الملصق",
  "lbl.refresh": "تحديث التتبّع",
  "lbl.tracking_updated": "تم تحديث التتبّع",
  "lbl.cancel": "إلغاء الملصق",
  "lbl.cancel_title": "إلغاء ملصق الشحن هذا؟",
  "lbl.cancel_body": "يُلغى الحجز لدى شركة الشحن وتعود المنتجات إلى غير المنفّذة.",
  "lbl.cancelled": "تم إلغاء الملصق",
  "lbl.cod_amount": "الدفع عند الاستلام {amount}",
  "lbl.fewer": "عرض أقل",
  "lbl.all_events": "عرض كل التحديثات ({n})",
  "lbl.status.label_pending": "جارٍ تجهيز الملصق",
  "lbl.status.active": "تم إنشاء الملصق",
  "lbl.status.delivered": "تم التوصيل",
  "lbl.status.failed": "فشل",
  "lbl.status.returned": "مُرتجع",
  "lbl.status.cancelled": "ملغى",
  "ship.cond.carrier": "سعر شركة الشحن",
  "ship.live_rate": "سعر مباشر من شركة الشحن",
  "ship.carrier_summary": "سعر {name} المباشر",
  "ship.fallback_short": "السعر البديل {v}",
  "ship.carrier_hint": "عند إتمام الطلب يكون السعر هو عرض شركة الشحن المباشر للطرد مضافاً إليه هامشك.",
  "ship.carrier_cheapest": "الخدمة الأرخص",
  "ship.markup_percent": "الهامش (%)",
  "ship.markup_percent_hint": "أضف نسبة إلى السعر، أو نسبة سالبة لتتحمّل جزءاً منه.",
  "ship.markup_fixed": "مبلغ ثابت يُضاف",
  "ship.fallback": "السعر البديل",
  "ship.fallback_hint": "يظهر إذا لم تستجب شركة الشحن في الوقت المناسب. اتركه فارغاً لإخفاء السعر حينها.",
};

export default couriersAr;
